module.exports = __webpack_public_path__ + "img/MTABAPPSPIRO+.d8387640.svg";